import eimg1 from '../images/events/img-1.jpg'
import eimg2 from '../images/events/img-2.jpg'
import eimg3 from '../images/events/img-3.jpg'
import eimg4 from '../images/events/img-2.jpg'

const Events = [
    {
        id: '1',
        eImg:eimg1,
        date:"25 Nov, 2023",
        eTitle: 'Help The Poor From Your Soal', 
        slug: 'Help-The-Poor',
        dec:'There are many variations of passages of Lorem Ipsum available.',
    },
    {
        id: '2',
        eImg:eimg2,
        date:"26 Nov, 2023",
        eTitle: 'Help Children Raise Out Of Proverty', 
        slug: 'Help-Children',
        dec:'There are many variations of passages of Lorem Ipsum available.',
    },
    {
        id: '3',
        eImg:eimg3,
        date:"27 Nov, 2023",
        eTitle: 'Provideing Education Is The Valuable Gift', 
        slug: 'Provideing-Education',
        dec:'There are many variations of passages of Lorem Ipsum available.',
    },
    {
        id: '4',
        eImg:eimg4,
        date:"25 Nov, 2023",
        eTitle: 'Let’s Save The Rare Birds From Hunting', 
        slug: 'Birds-From-Hunting',
        dec:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.',
    }
]

export default Events;